import { AssaysViewPortionResponse } from '@/components/assays-view/services/assays-view-portion/assays-view-portion.dto'
import { ProtocolIndexResponse } from '@/api/services/common/protocol/common-protocol.dto'

export interface AssaysViewBatchModalProtocolsCustomConfig {
    showOnlyCompatibles: boolean
}

export interface AssaysViewBatchModalProtocolsState {
    selectedPortions: AssaysViewPortionResponse[]
    uiComponentCode: string
    loading: boolean
    labIds: number[]
    showOnlyCompatibles: boolean
    protocols: ProtocolIndexResponse[]
}
export const initialAssaysViewBatchModalProtocolsState =
    (): AssaysViewBatchModalProtocolsState => ({
        selectedPortions: [],
        uiComponentCode: 'uicomponent.assaysview.protocolmodal',
        loading: false,
        labIds: [],
        showOnlyCompatibles: true,
        protocols: []
    })
